import React from 'react';
import PropTypes from 'prop-types';
import FileInput from './FileInput';
import FileItemsTable from './FileItemsTable';
import Title from '../base/Title/Title';
import textTranslates from './translate.json';
import './File.scss';

const AttachedFilesManageTable = ({id,files, onAddFileButtonClick, onPreviewFileButtonClick, onRemoveFileButtonClick,title, textDescription,filesTargetName, labelPhotoText}) => {
    return(
        <div
            id={id + "fileUploaderContainer"}
            className="col-xs-12">
            <Title
                id="attachments-files-title"
                title={title}
                small />
            <div className="col-xs-12">
                {labelPhotoText}
                {textDescription}
                <hr className="file-upload-hr" />
                <FileInput
                    id={id + "fileUploaderInput"}
                    onAddFileButtonClick={onAddFileButtonClick}
                    filesTargetName={filesTargetName}
                     />
                <FileItemsTable
                    files={files}
                    onFilePreviewButtonClick={onPreviewFileButtonClick}
                    onFileRemoveButtonClick={onRemoveFileButtonClick} />
            </div>
        </div>
    );
};

AttachedFilesManageTable.propTypes = {
    //Complaint positions attached files
    files: PropTypes.array,
    //Function triggered on add file button click
    onAddFileButtonClick: PropTypes.func,
    //Function triggered on preview file button click
    onPreviewFileButtonClick: PropTypes.func,
    //Function triggered on remove file button click
    onRemoveFileButtonClick: PropTypes.func,
    //Text to display
    textDescription: PropTypes.string,
    labelPhotoText: PropTypes.object
};

export default AttachedFilesManageTable;


// WEBPACK FOOTER //
// ./src/components/File/AttachedFilesManageTable.js